import { render, staticRenderFns } from "./VideoViewer.vue?vue&type=template&id=0d123a52&scoped=true&"
import script from "./VideoViewer.vue?vue&type=script&lang=js&"
export * from "./VideoViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d123a52",
  null
  
)

export default component.exports